import "data-layer-helper/dist/data-layer-helper";
import { getwebCallbackDatalayer } from "../call-backs-web";

const dataLayer = getwebCallbackDatalayer();

observe(dataLayer);

function observe(dataLayer) {
	return new DataLayerHelper(dataLayer, listener, true);
}

function sendGlobalMessage(event, message) {
	window.dispatchEvent(new CustomEvent(`webcall:${event}`, {
		bubbles: true,
		detail: {
			message: message
		}
	}));
}

function listener(model, message) {
	const { event } = message;
    switch (event) {
		default:
			sendGlobalMessage(event, message)
			break;
	}
}
